import {
  Battery,
  Camera,
  Clapperboard,
  Coffee,
  Film,
  Headphones,
  Laptop,
  Lightbulb,
  Mic2,
  Monitor,
  Moon,
  Music,
  Plug,
  Projector,
  Radio,
  Sparkles,
  Speaker,
  Star,
  Sun,
  Tv,
  UtensilsCrossed,
  Video,
  Volume2,
  Wifi,
  Zap,
} from 'lucide-react';
import { EquipmentFormData } from '../types/equipment.types';

export const AVAILABLE_ICONS = [
  { name: 'Volume2', icon: Volume2, label: 'Sonorisation' },
  { name: 'Mic2', icon: Mic2, label: 'Microphone' },
  { name: 'Projector', icon: Projector, label: 'Projecteur' },
  { name: 'Monitor', icon: Monitor, label: 'Écran' },
  { name: 'Laptop', icon: Laptop, label: 'Ordinateur' },
  { name: 'Wifi', icon: Wifi, label: 'WiFi' },
  { name: 'Coffee', icon: Coffee, label: 'Café' },
  { name: 'UtensilsCrossed', icon: UtensilsCrossed, label: 'Restauration' },
  { name: 'Camera', icon: Camera, label: 'Caméra' },
  { name: 'Music', icon: Music, label: 'Musique' },
  { name: 'Speaker', icon: Speaker, label: 'Haut-parleur' },
  { name: 'Headphones', icon: Headphones, label: 'Casque audio' },
  { name: 'Radio', icon: Radio, label: 'Radio' },
  { name: 'Tv', icon: Tv, label: 'Télévision' },
  { name: 'Video', icon: Video, label: 'Vidéo' },
  { name: 'Film', icon: Film, label: 'Film' },
  { name: 'Clapperboard', icon: Clapperboard, label: 'Clap' },
  { name: 'Lightbulb', icon: Lightbulb, label: 'Éclairage' },
  { name: 'Zap', icon: Zap, label: 'Électricité' },
  { name: 'Plug', icon: Plug, label: 'Prise' },
  { name: 'Battery', icon: Battery, label: 'Batterie' },
  { name: 'Sun', icon: Sun, label: 'Lumière naturelle' },
  { name: 'Moon', icon: Moon, label: 'Ambiance tamisée' },
  { name: 'Star', icon: Star, label: 'Premium' },
  { name: 'Sparkles', icon: Sparkles, label: 'Spécial' },
];

export const INITIAL_FORM: EquipmentFormData = {
  name: '',
  description: '',
  price: 0,
  unit: 'FCFA',
  iconName: '',
  minCapacity: null,
  maxCapacity: null,
  triggersRestaurant: false,
};

export const DEFAULT_S_CONF_EQUIPMENTS = [
  {
    name: 'Sonorisation',
    description: 'Système de sonorisation professionnel (Micro + Haut-parleurs)',
    price: 50000,
    unit: 'FCFA',
    iconName: 'Volume2',
    minCapacity: 15,
    triggersRestaurant: false,
  },
  {
    name: 'Couverture photo',
    description: 'Reportage photo complet de votre événement',
    price: 150000,
    unit: 'FCFA',
    iconName: 'Camera',
    minCapacity: 15,
    triggersRestaurant: false,
  },
  {
    name: 'Retransmission Live',
    description: 'Streaming en direct sur vos réseaux sociaux',
    price: 200000,
    unit: 'FCFA',
    iconName: 'Video',
    minCapacity: 15,
    triggersRestaurant: false,
  },
  {
    name: "Gestion de l'accueil",
    description: "Hôtesses d'accueil et enregistrement des participants",
    price: 100000,
    unit: 'FCFA',
    iconName: 'Sparkles',
    minCapacity: 15,
    triggersRestaurant: false,
  },
  {
    name: 'Place de parking',
    description: 'Places de parking sécurisées pour vos VIP',
    price: 50000,
    unit: 'FCFA',
    iconName: 'Zap',
    minCapacity: 15,
    triggersRestaurant: false,
  },
  {
    name: 'Restauration',
    description: 'Pause café, déjeuner ou cocktail',
    price: 0,
    unit: 'sur devis',
    iconName: 'UtensilsCrossed',
    minCapacity: 15,
    triggersRestaurant: true,
  },
];
